export const defaultCategoryOption = { key: "select", value: "Seçiniz" };
